// This is called on the product page, and also inside quickview.js
window.initProductScript = function (
    product,
    selectorID,
    scope,
    initUpsellVariantSync = true,
    isUpsellProduct = false
) {
    const closestSection = scope.closest('section')
    let currentVariant
    window.sliders = []
    window.mobileSliders = []
    window.newSwiper = function (el, options) {
        return new Swiper(el, options)
    }

    /**
     *
     * Removes disabled attributes on variant selectors
     *
     */
    function removeDisabledAttribute(els) {
        els.forEach(function (el, index) {
            el.classList.remove('disabled')
            el.textContent = window.inventory_text.add_to_cart
            el.removeAttribute('disabled')
        })
    }

    /**
     *
     * Adds disabled attributes to variant selectors
     *
     */
    function addDisabledAttribute(els) {
        els.forEach(function (el, index) {
            el.classList.add('disabled')
            el.textContent = window.inventory_text.sold_out
            el.setAttribute('disabled', 'disabled')
        })
    }

    /**
     *
     * Updates the "id" input values on elements across the page
     * Intention is to handle add to cart buttons further down the page than the hero
     * And also the sticky add to cart bar
     *
     */
    function _updateIDInput(els, variant) {
        els.forEach(function (el, index) {
            let thisForm = el.closest('form')
            let thisIDInput = thisForm.querySelector('[name="id"]')

            if (thisForm) {
                thisIDInput = thisForm.querySelector('[name="id"]')
            }

            if (thisIDInput) {
                thisIDInput.value = variant.id
            }
        })
    }

    /**
     *
     * Updates flashing stock indicator in product hero
     *
     */
    function _stockIndicator(el, stockStatus) {
        if (!el) return

        let statusMessages = {
            instock: inventory_text.low_stock_long,
            lowstock: inventory_text.in_stock_long,
            outofstock: inventory_text.sold_out_long,
        }

        el.classList.remove(...Object.keys(statusMessages))

        if (stockStatus) {
            el.classList.add(stockStatus)
            el.textContent = statusMessages[stockStatus]
        } else {
            el.textContent = ''
        }
    }

    /**
     *
     * The callback or shopify's "OptionSelectors" function
     * This runs when a variant is selected on a product page
     * It changes the stock status and price if the variant has diff prices
     * Also toggles the slider images to change
     *
     */
    var selectCallback = function (variant, selector) {
        var addToCartBtn = scope.querySelector('button[name="add"]'),
            otherAddToCartBtns = scope.querySelectorAll(
                'button[name="add"]:not(#product-add-to-cart)'
            ),
            productPrices = scope.querySelectorAll('[data-price]'),
            comparePrices = scope.querySelectorAll('[data-compare] s'),
            sellingPlanInput = scope.querySelector('[name="selling_plan"]'),
            stockIndicator = scope.querySelector('.stock-indicator')
        quantityInput = scope.querySelector('input[name="quantity"]')
        productAvailabilityNotice = scope.querySelector(
            '.js-availability-notice '
        )

        currentVariant = variant
        // console.log(variant);

        var productAvailability, productVariant

        if (productAvailabilityNotice) {
            ;((productAvailability =
                productAvailabilityNotice.querySelector('.js-availablilty')),
                (productVariant =
                    productAvailabilityNotice.querySelector('.js-varient')))
        }

        if (!addToCartBtn) {
            return
        }

        // Reset Quantity input field & availability notice
        quantityInput.value = 1
        productAvailabilityNotice?.classList.add('disabled')

        if (variant) {
            _updateIDInput(otherAddToCartBtns, variant)

            // if (typeof sliders !== 'undefined' && sliders['product-slider']) {
            // 	console.log('variantId: ', variant.id)
            // 	var thisImageSlide = scope
            // 		.closest('section')
            // 		.querySelector(`[data-variant-id*="${variant.id}"]`);

            // 	if (thisImageSlide && thisImageSlide.dataset.slideIndex) {
            // 		var thisSlideTo =
            // 			parseInt(thisImageSlide.dataset.slideIndex);
            // 		sliders['product-slider'].slideTo(thisSlideTo);
            // 	}
            // }

            var currentProduct
            if (scope != document && scope.classList.contains('modal')) {
                // currentProduct = currentQVItem;
            } else {
                currentProduct = product
            }

            if (currentProduct.variantStock[variant.id]) {
                var currentStock =
                    currentProduct.variantStock[variant.id].inventory
            }

            // Availability Notice
            if (productAvailability) {
                productAvailability.textContent = currentStock
            }

            if (productVariant) {
                productVariant.textContent = variant.title
            }

            // addToCartbtn

            // Enough inventory OR Track quantity is unchecked OR Continue selling when out of stock is checked
            if (variant.available) {
                // Inventory > 5 : In Stock
                if (currentStock >= 5) {
                    _stockIndicator(stockIndicator, 'instock')
                    productAvailabilityNotice?.classList.remove('invalid')
                }

                // Inventory > 0 : Low Stock
                else if (currentStock > 0) {
                    _stockIndicator(stockIndicator, 'lowstock')
                    productAvailabilityNotice?.classList.remove('invalid')
                }

                // Track Quantity button is checked : Out of Stock
                else if (variant.inventory_management != null) {
                    _stockIndicator(stockIndicator, 'outofstock')
                    productAvailabilityNotice?.classList.add('invalid')
                }

                // Track Quantity button is unchecked : No notice
                else if (variant.inventory_management == null) {
                    _stockIndicator(stockIndicator, false)
                    productAvailabilityNotice?.classList.add('invalid')
                }

                removeDisabledAttribute([addToCartBtn])
                removeDisabledAttribute(otherAddToCartBtns)

                if (currentStock > 0 || variant.inventory_management == null) {
                    addToCartBtn.textContent = window.inventory_text.add_to_cart
                } else {
                    addToCartBtn.textContent = window.inventory_text.pre_order
                }

                // 0 inventory AND Track Quantity is Checked AND Continue selling when out of stock is unchecked
            } else {
                addToCartBtn.textContent = window.inventory_text.sold_out
                addDisabledAttribute([addToCartBtn])
                addDisabledAttribute(otherAddToCartBtns)

                _stockIndicator(stockIndicator, 'outofstock')
                productAvailabilityNotice?.classList.add('invalid')
            }

            // Prices
            productPrices.forEach((productPrice) => {
                productPrice.innerHTML = Shopify.formatMoney(
                    variant.price,
                    window.money_format
                )

                productPrice.setAttribute('data-price', variant.price)
            })

            if (variant.compare_at_price > variant.price) {
                comparePrices.forEach(function (comparePrice) {
                    comparePrice.innerHTML = Shopify.formatMoney(
                        variant.compare_at_price,
                        window.money_format
                    )
                    comparePrice.style.display = 'block'
                })
            } else {
                comparePrices.forEach(function (comparePrice) {
                    comparePrice.style.display = 'none'
                })
            }
        } else {
            addToCartBtn.textContent = window.inventory_text.sold_out
            addDisabledAttribute([addToCartBtn])
            addDisabledAttribute(otherAddToCartBtns)

            _stockIndicator(stockIndicator, 'outofstock')
            productAvailabilityNotice?.classList.add('invalid')
        }
    }

    if (document.querySelector('#' + selectorID)) {
        new Shopify.OptionSelectors(selectorID, {
            product: product,
            onVariantSelected: selectCallback,
            enableHistoryState: false,
        })

        // allow custom inputs to change the generated <select>
        let allSelectorWrappers = scope.querySelectorAll('.selector-wrapper')

        /**
         *
         * This converts shopify's select boxes in to radio elements
         *
         */
        allSelectorWrappers.forEach((selectorWrapper, sIndex) => {
            let label = selectorWrapper.querySelector('label')
            let type = ''

            if (label) {
                type = _slugify(label.textContent)
            } else {
                // this is if there's only one type of variant, ie Color (no size)
                // Set scope
                type =
                    document.querySelector('#product-selectors').dataset.label
                label = document.createElement('label')
                label.textContent = type
                type = _slugify(type)
            }

            if (label) {
                let select = selectorWrapper.querySelector('select')
                let selectOptions = Array.from(
                    select.querySelectorAll('option')
                )

                let radioButtonsHTML = `<label class="uppercase font-bold">${type}:</label><div class="radio-selector">`
                selectOptions.forEach((option, index) => {
                    let customColour = ''

                    if (variant_colours) {
                        variant_colours.forEach((item, vIndex) => {
                            let thisSplit = item.split(':')
                            let thisColour = thisSplit[0]
                            let colour = option.textContent
                                .replace(/\s+/g, '-')
                                .toLowerCase()

                            if (colour === thisColour) {
                                customColour = `color:${thisSplit[1]};`
                            }
                        })
                    }

                    let selected = false

                    if (option.selected) {
                        selected = true
                    }

                    // Check if the product passed in, is an upsell and assign unique IDs
                    // Else, no need to assign unqiue IDs
                    if (isUpsellProduct) {
                        radioButtonsHTML += `
						<div class="radio-selector__option">
							<input 
								id="${type}-${index}-${selectorID}" 
								name="${type}-radio" 
								${selected ? 'checked' : ''} 
								type="radio"
								value="${option.value}">
							<label 
								style="${customColour}" 
								for="${type}-${index}-${selectorID}" 
								class="${_slugify(option.textContent)}">
								<span>${option.textContent}</span>
							</label>
						</div>`
                    } else {
                        radioButtonsHTML += `
						<div class="radio-selector__option">
							<input 
								id="${type}-${index}" 
								name="${type}-radio" 
								${selected ? 'checked' : ''} 
								type="radio"
								value="${option.value}">
							<label 
								style="${customColour}" 
								for="${type}-${index}" 
								class="${_slugify(option.textContent)}"
								data-variant-id="">
								<span>${option.textContent}</span>
							</label>
						</div>`
                    }
                })

                selectorWrapper.insertAdjacentHTML(
                    'afterbegin',
                    radioButtonsHTML
                )
            }

            label.textContent = `${label.textContent}: `

            if (
                type === 'color' &&
                label.closest('form').classList.contains('main-product-atc')
            ) {
                let newColorSpan = `<span class="dyn-color ms-2 text-capitalize"></span>`

                label.insertAdjacentHTML('beforeend', newColorSpan)
            }

            // add type class to selector
            selectorWrapper.classList.add('type-' + type)
        })

        /**
         *
         * Sync the selling plans across the page with the hero selector
         *
         */
        let allSellingPlans = document.querySelectorAll(
            '.subscriptions__group input'
        )

        let subPlanInputs = document.querySelectorAll('.sub-sticky')

        if (subPlanInputs.length) {
            allSellingPlans.forEach((el, index) => {
                if (el.checked) {
                    subPlanInputs.forEach((spEl, spIndex) => {
                        spEl.value = el.value
                    })
                }

                el.addEventListener('change', function () {
                    if (el.checked) {
                        subPlanInputs.forEach((spEl, spIndex) => {
                            spEl.value = el.value
                        })
                    }
                })
            })
        }

        _syncRadios()
        _updateTotalPrice()
    }

    /**
     *
     * This links the new radio buttons to shopify's select boxes
     * Changing a radio button, changes the select box and triggers the 'change' event
     * (Then, in shopify's script, not here, that 'change' event also changes the other hidden variant select option which triggers the callback function above)
     *
     */
    function _syncRadios() {
        let allRadioSelectors = [...scope.querySelectorAll('.radio-selector')]

        if (!isUpsellProduct) {
            let firstColor = scope.querySelector(
                '.type-color .radio-selector input:checked'
            )

            let dynColor = document.querySelector('.dyn-color')

            if (firstColor && dynColor) {
                dynColor.textContent = firstColor.value
            }
        }

        allRadioSelectors.forEach((radioSelector) => {
            let radioInputs = radioSelector.querySelectorAll(
                'input[type="radio"]'
            )

            radioInputs.forEach((radioInput) => {
                radioInput.addEventListener('change', function () {
                    let selectedValue = this.value
                    let selectElement =
                        this.closest('.selector-wrapper').querySelector(
                            'select'
                        )

                    if (selectElement) {
                        selectElement.value = selectedValue
                        selectElement.dispatchEvent(new Event('change'))
                    }

                    // Syncs the upsell selected options to match the main product product when an option is selected on the main product.
                    _syncUpsellOptionsToMain(this)

                    // Swap out the featured image for the image that matches the correct color variant only on the upsells.
                    _fetchAndReplaceUpsellImage(radioInput)

                    // Update dynamic color name.
                    _dynNameColor(radioInput)

                    // Navigate to the top of product hero page only on mobile.
                    _mobileNavigateToTop(radioInput)

                    // Hide/Show product hero slide images based on the color selected.
                    // _imageColorMatch(radioInput)

                    // Update total price as the options are selected.
                    _updateTotalPrice()
                })
            })
        })
    }

    function _syncUpsellOptionsToMain(currentRadioInputTarget) {
        if (!initUpsellVariantSync) return

        let allUpsellRadios = [
            ...closestSection.querySelectorAll(
                '.product-upsell-card .radio-selector input[type="radio"]'
            ),
        ]

        if (allUpsellRadios.length === 0) return

        allUpsellRadios.forEach((radio) => {
            if (radio.value === currentRadioInputTarget.value) {
                radio.click()
            }
        })
    }

    function _fetchAndReplaceUpsellImage(currentRadioInput) {
        if (
            !isUpsellProduct ||
            currentRadioInput.getAttribute('name') != 'color-radio'
        )
            return

        let upsellCard = scope.closest('.product-upsell-card')
        let featureImage = upsellCard.querySelector(
            '.product-upsell-card__feature-img img'
        )
        let newFeatureImageSrc = currentVariant.featured_image.src

        // Check if the upsell card & feature image elements exist
        // Also, check if the selected variant has an image
        if (!upsellCard || !featureImage || !newFeatureImageSrc) return

        // Update both src & srcset. Also, add timestamp on each request to minimise caching issues.
        featureImage.src = `${newFeatureImageSrc}?crop=center&height=181&width=172&t=${new Date().getTime()}`
        featureImage.srcset = `${newFeatureImageSrc}?crop=center&height=181&width=172&t=${new Date().getTime()}`
    }

    function _dynNameColor(currentRadioInput) {
        if (
            isUpsellProduct ||
            currentRadioInput.getAttribute('name') != 'color-radio'
        )
            return

        document.querySelector('.dyn-color').textContent =
            currentRadioInput.value
    }

    function _mobileNavigateToTop(currentRadioInput) {
        if (
            !isUpsellProduct &&
            currentRadioInput.getAttribute('name') === 'color-radio' &&
            window.innerWidth < 768
        ) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }
    }

    // TODO: Ensure the global variables are only initialised on the product page.
    // Solution: Check if the closest section element contains 'section-producthero'.
    if (!isUpsellProduct) {
        /*
            On product page load, the original slides are stored in memory to ensure
            we can reference them when updating or removing the slide elements.
        */
        window.productSliderSlides = []
        window.navSliderSlides = []
        window.mergedSlides = []

        window.productSliderSlides = closestSection.querySelectorAll(
            '#product-slider .swiper-slide'
        )

        window.navSliderSlides = closestSection.querySelectorAll(
            '#product-slider-nav .swiper-slide'
        )

        window.mergedSlides = [
            ...window.productSliderSlides,
            ...window.navSliderSlides,
        ]
    }

    async function _imageColorMatch(currentRadioInput) {
        // If the script is called on a upsell product or the option selected isn't a color option. Return.
        if (
            isUpsellProduct ||
            currentRadioInput.getAttribute('name') != 'color-radio'
        )
            return

        // Target the swiper wrappers for both the product hero & control swipers.
        const productSliderWrapper = document.querySelector(
            '#product-slider .swiper-wrapper'
        )

        const navSliderWrapper = document.querySelector(
            '#product-slider-nav .swiper-wrapper'
        )

        // Destroy both swipers
        window.sliders['product-slider']?.destroy()
        window.productSliderNav?.destroy()

        // Re-populate both swipers with the all the original slide elements.
        for (const slide of window.productSliderSlides) {
            productSliderWrapper.insertAdjacentElement('beforeend', slide)
        }
        for (const slide of window.navSliderSlides) {
            navSliderWrapper.insertAdjacentElement('beforeend', slide)
        }

        // Init both swipers
        window.productSliderNav = window.newSwiper('#product-slider-nav', {
            speed: 600,
            loop: false,
            slidesPerView: 2,
            spaceBetween: 7,
            centeredSlides: false,
            slideToClickedSlide: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            controller: {},
            autoplay: false,
            breakpoints: {
                768: {
                    spaceBetween: 14,
                },
            },
        })

        window.sliders['product-slider'] = await window.newSwiper(
            '#product-slider',
            {
                speed: 600,
                loop: false,
                slideToClickedSlide: true,
                spaceBetween: 20,
                slidesPerView: 1,
                navigation: {
                    nextEl: closestSection.querySelector('.swiper-next'),
                    prevEl: closestSection.querySelector('.swiper-prev'),
                },
                thumbs: {
                    swiper: window.productSliderNav,
                },
            }
        )

        // Loop through all slides(main & controller) and remove the slides that doesn't match the color selected.
        for (const slide of window.mergedSlides) {
            let slideImage = slide.querySelector('img')

            if (slideImage.alt && slideImage.alt !== currentRadioInput.value) {
                slide.remove()
            }
        }

        // Update the swiper so swiperjs can re-evualte the indexing of each slide.
        window.sliders['product-slider'].update()
        // window.sliders['product-slider'].thumbs.swiper.update();
    }

    function _updateTotalPrice() {
        if (!closestSection) return

        let totalPriceEl = closestSection.querySelector(
            '#upsell-complete-price'
        )
        if (!totalPriceEl) return

        let allPriceEls = [...closestSection.querySelectorAll('[data-price]')]

        // Get all the price values and convert to Integer
        let allPriceValues = allPriceEls.map((priceEl) =>
            Number(priceEl.getAttribute('data-price'))
        )

        // Get the sum
        let totalPrice = allPriceValues.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
        )

        // Format the new total
        let totalPriceFormatted = '$' + totalPrice / 100

        totalPriceEl.textContent = totalPriceFormatted
    }

    function _slugify(string) {
        return string.toLowerCase().replace(/\s+/g, '-').trim()
    }

    // Clear default size selection
    if (scope.classList.contains('main-product-atc')) {
        let mainATCFormSizeRadios = document.querySelectorAll(
            ".main-product-atc input[name='size-radio']"
        )

        if (mainATCFormSizeRadios.length) {
            mainATCFormSizeRadios.forEach((input) => (input.checked = false))
        }
    }
}

/**
 * ===== CART BADGE UPDATE FUNCTIONALITY =====
 * This dispatches events to update the cart badge in the header
 */
function dispatchCartUpdateEvent() {
    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            const event = new CustomEvent('cart:updated', {
                detail: cart,
                bubbles: true,
            })
            document.dispatchEvent(event)
        })
        .catch((error) => {
            console.error('Error fetching cart:', error)
        })
}

// Listen for form submissions and update cart badge
document.addEventListener('submit', function (event) {
    const form = event.target

    // Check if this is an add to cart form
    if (form.querySelector('[name="add"]')) {
        // Don't prevent default - let existing handler work
        // Update cart badge after a short delay to allow form to submit
        setTimeout(() => {
            dispatchCartUpdateEvent()
        }, 800)
    }
})
